export const NOTIFICATION_CONFIGURATION_TAG_NAME = 'notification-configuration-container' as const;
